import Vue from 'vue'
function setNestedValue (fieldName, dataItem, value, reactable = false) {
  if (!fieldName || !dataItem || typeof dataItem !== 'object') {
    return dataItem
  }

  const path = fieldName.replace(/([^.])\[(\d+)\]/g, '$1.$2').replace(/\[(\d+)\]/, '$1').split('.')
  const propName = path.pop()
  if (!propName) {
    return dataItem
  }

  let parent = dataItem
  for (let i = 0; i < path.length; i++) {
    const key = path[i]
    if (!(key in parent)) {
      if (value === undefined) {
        return dataItem
      }
      const nextKey = path[i + 1]
      const auxValue = nextKey && nextKey.match(/^(0|[1-9]\d*)$/)?.[1] < Number.MAX_SAFE_INTEGER ? [] : {}
      set(key, parent, auxValue, reactable)
    }
    parent = parent[key]
  }
  if (value !== undefined) {
    set(propName, parent, value, reactable)
  } else {
    remove(propName, parent)
  }
  return dataItem
}


function set (propName, item, value, reactable = false) {
  if (reactable && !Object.hasOwnProperty.call(item, propName)) {
    Vue.set(item, propName, value)
  } else {
    item[propName] = value
  }
}

function remove (propName, parent) {
  if (Array.isArray(parent) && propName && propName.match(/^(0|[1-9]\d*)$/)?.[1] < Number.MAX_SAFE_INTEGER) {
    const index = Number(propName)
    if (index >= 0 && index < parent.length) {
      parent.splice(index, 1)
    }
  } else {
    delete parent[propName]
  }
}

export default setNestedValue
